import { Permissions, Pagination } from '@factorin/domain';

import { withUrl, list, Request, post } from '../rest';


export type PermissionBody = {
    Name: string;
    Type: string;
}

const permissionsPart = withUrl('permissions');

export const permissions = {
    ...list<Permissions.Permission, Pagination.Request>(permissionsPart()),

    create: post<Request.Body<PermissionBody>, void>(
        ({ body }) => permissionsPart({
            body,
        }),
    ),
};
